"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var ImagePicker_1 = __importDefault(require("../../../../common/ImagePicker/ImagePicker"));
var ReactModal_1 = __importDefault(require("../../../../common/Modal/ReactModal"));
var TextArea_1 = __importDefault(require("../../../../common/TextInput/TextArea"));
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var general_1 = require("../../../../lib/general");
var Mutation_1 = require("../../Graphql/Mutation");
var Queries_1 = require("../../Graphql/Queries");
var Queries_2 = require("../Graphql/Queries");
var CategorySelector_1 = __importDefault(require("../Selectors/CategorySelector"));
var DataType_1 = __importDefault(require("../Selectors/DataType"));
var DiseaseInfoDetailSelector_1 = __importDefault(require("../Selectors/DiseaseInfoDetailSelector"));
var QuestionSelector_1 = __importDefault(require("../Selectors/QuestionSelector"));
var QuestionType_1 = __importDefault(require("../Selectors/QuestionType"));
var validate_1 = require("../validate");
var DiseaseQuestionAnswer_1 = __importDefault(require("./DiseaseQuestionAnswer"));
var QuestionTable_1 = __importDefault(require("./QuestionTable"));
var DiseaseQuestion = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var organization = (0, org_hook_1.useOrg)().organization;
    // const { disease } = useDis();
    var arr1 = props.languages, audioRef = (0, react_1.createRef)();
    // const { data: dataParentChild } = useQuery(
    //   GET_DISEASE_CATEGORY_PARENT_CHILD,
    //   {
    //     variables: { organization_id: organization.id, disease_id: disease.id },
    //     notifyOnNetworkStatusChange: true,
    //   },
    // );
    var _j = (0, react_1.useState)(null), error = _j[0], setError = _j[1];
    var _k = (0, react_i18next_1.useTranslation)(), t = _k.t, i18n = _k.i18n;
    var getCurrentLang = i18n.language;
    var _l = (0, react_1.useState)({
        id: null,
        name: JSON.stringify(props.languages),
        category: null,
        exam_type: null,
        data_type: null,
        sorting_order: null,
        answer: [],
        organization_id: organization.id,
        disease_info_detail: null,
        audio: arr1,
    }), formData = _l[0], setFormData = _l[1];
    var _m = (0, react_1.useState)({ audio: null }), audioFile = _m[0], setAudioFile = _m[1];
    var _o = (0, react_1.useState)([]), DiseaseInfoDetailList = _o[0], setDiseaseInfoDetailList = _o[1];
    var _p = (0, react_1.useState)(null), success = _p[0], setSuccess = _p[1];
    var _q = (0, react_1.useState)([]), questionSortingArr = _q[0], setQuestionSortingArr = _q[1];
    var _r = (0, react_1.useState)(false), deleteModal = _r[0], setDeleteModal = _r[1];
    var _s = (0, react_1.useState)(null), deleteRow = _s[0], setDeleteRow = _s[1];
    var _t = (0, client_1.useLazyQuery)(Queries_1.GET_EXAM_QUESTION_ORDER, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only",
    }), getExamDisease = _t[0], examDiseaseResponse = _t[1];
    var upsertExamQuestion = (0, client_1.useMutation)(Mutation_1.UPSERT_DISEASE_QUESTION_ANSWER, {
        fetchPolicy: "network-only",
        refetchQueries: ["getDiseaseCategory", Queries_2.GET_DISEASE_CATEGORY_PARENT_CHILD],
    })[0];
    var getQuestionAnswer = (0, client_1.useLazyQuery)(Queries_1.GET_QUESTION_ANSWER, {
        variables: { organization_id: organization.id },
    })[0];
    var updateQuestionExamStatus = (0, client_1.useMutation)(Mutation_1.UPDATA_QUESTION_EXAM_STATUS, {
        fetchPolicy: "network-only",
        refetchQueries: ["getDiseaseCategory", Queries_2.GET_DISEASE_CATEGORY_PARENT_CHILD],
    })[0];
    var resetDocumentRef = function () {
        audioRef.current.value = null;
    };
    var reformatForm = function () {
        setFormData({
            id: null,
            name: JSON.stringify(props.languages),
            category: null,
            exam_type: null,
            data_type: null,
            sorting_order: null,
            answer: [],
            organization_id: organization.id,
            disease_info_detail: null,
            audio: arr1,
        });
    };
    (0, react_1.useEffect)(function () {
        getQuestionAnswer();
        reformatForm();
        resetDocumentRef();
    }, []);
    (0, react_1.useEffect)(function () {
        resetDocumentRef();
        setAudioFile({ audio: null });
    }, [getCurrentLang]);
    (0, react_1.useEffect)(function () {
        if (props.clickStatus) {
            props.updateSaveClickStatus();
            saveQuestionAnswer();
        }
    }, [props.clickStatus]);
    var getVal = function (obj) {
        var tmp = [];
        Object.keys(obj).forEach(function (key) {
            var lang = key, name = obj[key] === "" ? null : obj[key];
            tmp.push({
                lang: lang,
                name: name,
            });
        });
        return tmp;
    };
    var saveQuestionAnswer = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var validateResponse = (0, validate_1.ValidateEducationQuestion)(formData, getCurrentLang);
        if (validateResponse.status === "error") {
            setError(validateResponse);
        }
        else {
            var audioArr = getVal(formData.audio);
            var payload = {
                id: formData.id,
                disease_info_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                    ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                    : formData.category,
                exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                    ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                    : formData.exam_type,
                question: formData.name,
                order_by: formData.sorting_order !== null
                    ? parseInt(((_e = formData.sorting_order) === null || _e === void 0 ? void 0 : _e.value)
                        ? (_f = formData.sorting_order) === null || _f === void 0 ? void 0 : _f.value
                        : formData.sorting_order)
                    : null,
                data_type_id: ((_g = formData.data_type) === null || _g === void 0 ? void 0 : _g.id)
                    ? (_h = formData.data_type) === null || _h === void 0 ? void 0 : _h.id
                    : formData.data_type,
                status: true,
                answer: formData.answer,
                organization_id: organization.id,
                disease_info_detail_id: formData.disease_info_detail.id,
                audio: audioArr,
            };
            upsertExamQuestion({
                variables: {
                    input: [payload],
                },
            })
                .then(function (res) {
                setSuccess(res.data.upsertQuestionAnswer);
                reformatForm();
            })
                .catch(function () { });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        if (formData.exam_type && formData.category) {
            getExamDisease({
                variables: {
                    disease_info_category_id: ((_a = formData.category) === null || _a === void 0 ? void 0 : _a.id)
                        ? (_b = formData.category) === null || _b === void 0 ? void 0 : _b.id
                        : formData.category,
                    exam_type_id: ((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.id)
                        ? (_d = formData.exam_type) === null || _d === void 0 ? void 0 : _d.id
                        : formData.exam_type,
                    organization_id: organization.id,
                },
            });
        }
    }, [formData]);
    var onHandleChange = function (value, name, type) {
        setError(null);
        if (type === "json") {
            var dataObj_1 = JSON.parse(formData[name]);
            dataObj_1[getCurrentLang] = value;
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = JSON.stringify(dataObj_1), _a)));
            });
        }
        else if (type === "obj") {
            var audio_file_1 = value.audio_file;
            if (audio_file_1) {
                setAudioFile({
                    audio: audio_file_1.name,
                });
                setFormData(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), (_a = {}, _a["audio"] = __assign(__assign({}, prevState["audio"]), (_b = {}, _b[getCurrentLang] = audio_file_1, _b)), _a)));
                });
            }
        }
        else {
            setFormData(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), (_a = {}, _a[name] = value, _a)));
            });
        }
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        setQuestionSortingArr([]);
        if (((_b = (_a = examDiseaseResponse === null || examDiseaseResponse === void 0 ? void 0 : examDiseaseResponse.data) === null || _a === void 0 ? void 0 : _a.getQuestionOrder) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            var list = (_c = examDiseaseResponse === null || examDiseaseResponse === void 0 ? void 0 : examDiseaseResponse.data) === null || _c === void 0 ? void 0 : _c.getQuestionOrder;
            var output_1 = [];
            list.map(function (item) {
                var id = item.id, order_by = item.order_by, question = item.question, value = order_by, label = "before ".concat((0, general_1.isJsonWithAvailableLang)(question, getCurrentLang, t)), sorting_id = order_by;
                output_1.push({
                    id: id,
                    value: value,
                    label: lodash_1.default.truncate(label, {
                        length: 60,
                        omission: " ...",
                    }),
                    sorting_id: sorting_id,
                    question: question,
                });
            });
            setQuestionSortingArr(output_1);
        }
    }, [examDiseaseResponse, getCurrentLang, formData]);
    (0, react_1.useEffect)(function () {
        if (success) {
            var timer_1 = setTimeout(function () {
                setSuccess(null);
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [success]);
    var onDeleteQuestion = function () {
        updateQuestionExamStatus({
            variables: {
                id: deleteRow.id,
                status: false,
                organization_id: organization.id,
            },
        }).then(function () {
            reformatForm();
            setDeleteModal(false);
            setDeleteRow(null);
            setSuccess("deleted_successfully");
        });
    };
    var onEditQuestion = function (item) {
        var formatted_exam_type = {
            id: item.exam_type.id,
            value: item.exam_type.id,
            label: (0, general_1.isJsonWithAvailableLang)(item.exam_type.name, getCurrentLang, t),
            name: item.exam_type.name,
        };
        var output = [];
        if (item.answers.length > 0) {
            item.answers.map(function (l) {
                var answer = l.answer, description = l.description, id = l.id, is_correct = l.is_correct, order_by = l.order_by, status = l.status;
                output.push({
                    answer: answer,
                    description: description,
                    is_correct: is_correct,
                    id: id,
                    order_by: order_by,
                    status: status,
                });
            });
        }
        var payload = {
            id: item.id,
            name: item.question,
            category: item.disease_info_category_id,
            exam_type: item.exam_type.id,
            exam_type_item: formatted_exam_type,
            data_type: item.data_type_id,
            data_type_item: item.data_type,
            sorting_order: item.order_by,
            answer: output,
            organization_id: organization.id,
            audio: props.languages,
            disease_info_detail: DiseaseInfoDetailList.length > 0 &&
                DiseaseInfoDetailList.find(function (l) { return l.id === item.disease_info_detail_id; }),
        };
        setFormData(payload);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        success && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t(success), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: "top-center", rtl: false })),
        react_1.default.createElement(ReactModal_1.default, { modalCardStyle: { height: "10vh" }, isOpen: deleteModal, showSaveButton: true, title: t("delete_confirmation"), isClose: function () { return setDeleteModal(false); }, onSaveClick: function () {
                onDeleteQuestion();
            } }, "Are you sure that you want to delete the selected item?"),
        react_1.default.createElement("div", { className: "form-container" },
            react_1.default.createElement(CategorySelector_1.default, { error: error && error.field === "category" && error.message, label: t("category"), list: ((_a = props.getResponse) === null || _a === void 0 ? void 0 : _a.data)
                    ? props.getResponse.data.getDiseaseCategory
                    : [], updateCategory: function (val) {
                    onHandleChange(val, "category", "");
                    setDiseaseInfoDetailList(val.disease_info_detail);
                }, value: formData.category }),
            react_1.default.createElement(DiseaseInfoDetailSelector_1.default, { error: error && error.field === "disease_info_detail" && t(error.message), label: t("disease_info_detail"), list: DiseaseInfoDetailList, onChange: function (val) {
                    onHandleChange(val, "disease_info_detail", "");
                }, value: formData.disease_info_detail }),
            react_1.default.createElement(QuestionType_1.default, { error: error && error.field === "exam_type" && error.message, label: t("exam_type"), onChange: function (val) {
                    onHandleChange(val, "exam_type", "");
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a["answer"] = [], _a)));
                    });
                }, value: formData.exam_type }),
            react_1.default.createElement(TextArea_1.default, { error: error && error.field === "name" && error.message, label: t("name"), onChange: function (e) { return onHandleChange(e.target.value, "name", "json"); }, value: (0, general_1.isJsonWithAvailableLang)(formData.name, getCurrentLang.toLowerCase(), t) }),
            react_1.default.createElement(DataType_1.default, { error: error && error.field === "data_type" && error.message, label: t("data_type"), onChange: function (val) { return onHandleChange(val, "data_type", ""); }, value: formData.data_type }),
            react_1.default.createElement(QuestionSelector_1.default, { error: error && error.field === "sorting_order" && error.message, label: t("sorting_order"), onChange: function (val) { return onHandleChange(val, "sorting_order", ""); }, value: formData.sorting_order, list: questionSortingArr }),
            react_1.default.createElement(ImagePicker_1.default, { fileName: audioFile, id: "audio", imagechange: function (audio_file) {
                    var file = { audio_file: audio_file };
                    onHandleChange(file, "audio", "obj");
                }, imgref: audioRef, label: t("audio_question"), mediatype: "audio" }),
            (typeof formData.exam_type != "string" &&
                ((_b = formData.exam_type) === null || _b === void 0 ? void 0 : _b.name) &&
                JSON.parse((_c = formData.exam_type) === null || _c === void 0 ? void 0 : _c.name)["en"].toLowerCase() ===
                    "evaluate") ||
                (typeof formData.exam_type === "string" &&
                    ((_d = formData.exam_type_item) === null || _d === void 0 ? void 0 : _d.name) &&
                    JSON.parse((_e = formData.exam_type_item) === null || _e === void 0 ? void 0 : _e.name)["en"].toLowerCase() ===
                        "evaluate") ? (react_1.default.createElement(DiseaseQuestionAnswer_1.default, { deleteMessage: function (msg) { return deleteRow(msg); }, editableAnswers: formData.answer, error: error, languages: props.languages, handleMultipleAnswer: function (e) {
                    setFormData(function (prevState) {
                        var _a;
                        return (__assign(__assign({}, prevState), (_a = {}, _a["answer"] = e, _a)));
                    });
                } })) : (react_1.default.createElement(react_1.default.Fragment, null))),
        react_1.default.createElement(QuestionTable_1.default, { hasHierarchy: false, 
            // list={dataParentChild?.getDiseaseCategoryByParentChild}
            list: (formData === null || formData === void 0 ? void 0 : formData.disease_info_detail) &&
                ((_g = (_f = formData === null || formData === void 0 ? void 0 : formData.disease_info_detail) === null || _f === void 0 ? void 0 : _f.exam_questions) === null || _g === void 0 ? void 0 : _g.length) > 0
                ? (_h = formData === null || formData === void 0 ? void 0 : formData.disease_info_detail) === null || _h === void 0 ? void 0 : _h.exam_questions
                : [], onQuestiondelete: function (e) {
                setDeleteRow(e);
                setDeleteModal(true);
            }, onQuestionedit: function (item) { return onEditQuestion(item); } })));
};
exports.default = DiseaseQuestion;
